import Cookies from 'js-cookie'

const TOKEN_KEY = 'admin_token'

export function getToken() {
  // cookie 和 localStorage 双读，任意一处有值即可
  return Cookies.get(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  if (!token) return
  localStorage.setItem(TOKEN_KEY, token)
  return Cookies.set(TOKEN_KEY, token, { expires: 7 })
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  return Cookies.remove(TOKEN_KEY)
}
